import { render, staticRenderFns } from "./flowList.vue?vue&type=template&id=98f16c3e&scoped=true"
import script from "./flowList.vue?vue&type=script&lang=js"
export * from "./flowList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f16c3e",
  null
  
)

export default component.exports